export default "__VITE_ASSET__BfazjLIe__"